export default function downloadFile(response, fileName){
	if (window.navigator && window.navigator.msSaveOrOpenBlob){
		// IE variant
		window.navigator.msSaveOrOpenBlob(new Blob([response], { type: response.type }), fileName)
	}
	else {
		const blob = new Blob([response], { type: response.type })
		const url = window.URL.createObjectURL(blob)
		const link = document.createElement("a")
		link.href = url
		link.setAttribute("download", fileName)
		document.body.appendChild(link)
		link.click()
		link.remove()
	}
	return true
}

//имя файла с сервера
export function downloadFile_(response) {
	if (window.navigator && window.navigator.msSaveOrOpenBlob) {
		// IE variant
		window.navigator.msSaveOrOpenBlob(
			new Blob([response.data], {type: response.data.type})
		)
	} else {
		const blob = new Blob([response.data], {type: response.data.type});
		const url = window.URL.createObjectURL(blob);
		const link = document.createElement('a');
		link.href = url;
		const disposition = response.headers['content-disposition'];
		let fileName = 'unknown';
		if (disposition && disposition.startsWith("attachment")) {
			const name = getFileName(disposition)
			if (name) fileName = name
		}
		link.setAttribute('download', fileName);
		document.body.appendChild(link);
		link.click();
		link.remove();
		window.URL.revokeObjectURL(url);
	}
}

function getFileName(disposition) {
	const utf8FilenameRegex = /filename\*=UTF-8''([\w%-.]+)(?:; ?|$)/i;
	const asciiFilenameRegex = /filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;

	let fileName;
	if (utf8FilenameRegex.test(disposition)) {
		fileName = decodeURIComponent(utf8FilenameRegex.exec(disposition)[1]);
	} else {
		const matches = asciiFilenameRegex.exec(disposition);
		if (matches != null && matches[2]) {
			fileName = matches[2];
		}
	}
	return fileName;
}